module.exports = __webpack_public_path__ + "static/logo-3327c93d94a34605d684737c0744feab.png";